const StartMode_Icon = ({ className = "" }) => {
  return (
    <svg
      width="26"
      height="26"
      className={className}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M19 7H7C6.1675 7 5.5075 7.6675 5.5075 8.5L5.5 17.5C5.5 18.3325 6.1675 19 7 19H19C19.8325 19 20.5 18.3325 20.5 17.5V8.5C20.5 7.6675 19.8325 7 19 7ZM19 17.5H7V13H19V17.5ZM19 10H7V8.5H19V10Z"
        fill="#79C8B0"
      />
      <path
        d="M19 7H7C6.1675 7 5.5075 7.6675 5.5075 8.5L5.5 17.5C5.5 18.3325 6.1675 19 7 19H19C19.8325 19 20.5 18.3325 20.5 17.5V8.5C20.5 7.6675 19.8325 7 19 7ZM19 17.5H7V13H19V17.5ZM19 10H7V8.5H19V10Z"
        fill="url(#paint0_linear_1_18376)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_18376"
          x1="17.6875"
          y1="17"
          x2="10.8082"
          y2="8.85011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default StartMode_Icon;
